import React from "react";

const ShareIcon = (props: any) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.66602 14.6222C4.66602 11.726 7.01505 9.37695 9.91131 9.37695C12.8076 9.37695 15.1566 11.726 15.1566 14.6222C15.1566 17.5185 12.8076 19.8675 9.91131 19.8675C9.29736 19.8675 8.69675 19.7608 8.14953 19.5606"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M20.4024 10.7522C22.0831 10.7522 23.4455 9.38973 23.4455 7.70909C23.4455 6.02844 22.0831 4.66602 20.4024 4.66602C18.7218 4.66602 17.3594 6.02844 17.3594 7.70909C17.3594 9.38973 18.7218 10.7522 20.4024 10.7522Z"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M20.1622 24.5002C21.8429 24.5002 23.2053 23.1378 23.2053 21.4571C23.2053 19.7765 21.8429 18.4141 20.1622 18.4141C18.4816 18.4141 17.1191 19.7765 17.1191 21.4571C17.1191 23.1378 18.4816 24.5002 20.1622 24.5002Z"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M14.1426 11.5258L17.853 9.37695"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M14.3418 17.4395L17.5584 19.8686"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
    </svg>
  );
};

export default ShareIcon;
